import { Feature } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { config } from './config';

@Feature()
export class InsertChartFeature extends BaseToolbarFeature {
    id = config.id;
    constructor() {
        super();
    }

    public getFontSize() {
        const values = this.getMenuManager()?.toolbarMenu().values;
        return values?.fontSize;
    }

    public getFontSizeName() {
        const disableItems = this.getMenuManager()?.disableItemIds() || [];
        if (disableItems.find(item => item.id === this.id)) {
            return i18n.t('字号');
        }
        const values = this.getMenuManager()?.toolbarMenu().values;
        const fontSize = values?.fontSize || '';
        return fontSize.replace('font-size-', '').replace('pt', '');
    }
}
